<template>
    <LegalAgreementPdfContent :content="legalAgreementContent" />
</template>

<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {useRoute} from '#imports';
    import type {LegalAgreementLanguage, LegalAgreementType} from '@api';
    import LegalAgreementPdfContent from '~/components/legal-agreements/LegalAgreementPdfContent.vue';
    import {useLegalAgreementsStore} from '~/stores/legal-agreements.store';

    const route = useRoute();
    const legalAgreementsStore = useLegalAgreementsStore();

    const agreementType = route.params.agreementType as LegalAgreementType;
    const versionId = route.params.versionId as string;
    const language = route.params.language as LegalAgreementLanguage;

    await legalAgreementsStore.fetchVersionContent(agreementType, versionId, language);

    const {legalAgreementContent} = storeToRefs(legalAgreementsStore);
</script>
